import { useTranslation } from "react-i18next";

export default function EmptySensors({ width = 100, title = "sensor_details.empty_sensors" }) {
  const { t } = useTranslation();
  return (
    <div className="p-5 bg-light text-center">
      <img
        data-testid="empty-sensors-image"
        name="empty_sensors"
        alt=""
        width={width}
        src="/empty_project.svg"
      />
      <h5 className="my-4">{t(title)}</h5>
    </div>
  );
}
